import React from 'react';

export default () => (
  <svg
    focusable='false'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M18.875 10.206a.763.763 0 0 1 .404.118.748.748 0 0 1 .126.102l2.5 2.5a.75.75 0 0 1-1.06 1.06l-1.24-1.238a7.625 7.625 0 0 1-13.15 4.69.75.75 0 0 1 1.09-1.03 6.125 6.125 0 0 0 10.552-3.612l-1.192 1.19a.75.75 0 0 1-1.06-1.06l2.5-2.5a.753.753 0 0 1 .53-.22l-.073.003a.754.754 0 0 1 .044-.003zM9.423 5.034a7.625 7.625 0 0 1 8.457 2.322.75.75 0 0 1-1.157.955 6.125 6.125 0 0 0-10.848 3.895l-.001.065 1.22-1.22a.75.75 0 0 1 .977-.073l.084.073a.75.75 0 0 1 0 1.06l-2.483 2.485a.748.748 0 0 1-1.094 0l-2.483-2.485a.75.75 0 0 1 1.06-1.06l1.219 1.218.001-.064a7.625 7.625 0 0 1 4.791-7.074z' />
  </svg>
);
